export default {
  Header: {
    Title: 'Tasks',
    Summary: '#{totalTasks} total · #{dueToday} due today',
  },
  Sections: {
    Today: 'Today',
    ThisWeek: 'This Week',
  },
  AddTask: {
    ClientConnections: 'Client Associations',
  },
  TaskItem: {
    UnknownClient: 'Unknown Client',
  },
  Empty: 'No tasks right now.',
};
